import React from 'react';
import ProductViewTemplate from '@/components/partials/ProductView/ProductViewTemplate';
import { ProductViewModes } from '@/utils/productStateUtils';
import { useProductChangeRequest } from '@/components/partials/ProductView/ProductChangeRequest/useProductChangeRequest';

const ProductChangeRequest = () => {
  const viewHook = useProductChangeRequest();

  return (
    <ProductViewTemplate
      productViewMode={ProductViewModes.ChangeRequest}
      viewHook={viewHook}
    />
  );
};

export default ProductChangeRequest;
